import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  DxButtonModule,
  DxChartModule,
  DxCheckBoxModule,
  DxDataGridModule,
  DxDateBoxModule,
  DxDateRangeBoxModule,
  DxDropDownBoxModule,
  DxDropDownButtonModule,
  DxFormModule,
  DxListModule,
  DxLoadPanelModule,
  DxPopupModule,
  DxPopoverModule,
  DxScrollViewModule,
  DxSelectBoxModule,
  DxTagBoxModule,
  DxTextBoxModule,
  DxValidatorModule,
} from 'devextreme-angular';
import { ModalWindowModule } from '../../components/modal-window/modal-window.module';
import { ReportUnavailableComponent } from '../../components/report-unavailable/report-unavailable.component';
import { ProductionComparisonDashboardComponent } from './production-comparison-dashboard/production-comparison-dashboard.component';
import { ProductionComparisonExportService } from './production-comparison-dashboard/production-comparison-export.service';
import { ProductionComparisonExportBuilderService } from './production-comparison-dashboard/production-comparison-export-builder.service';
import { ProductionComparisonPdfPreviewComponent } from './production-comparison-dashboard/production-comparison-pdf-preview/production-comparison-pdf-preview.component';
import { ProductionComparisonPdfService } from './production-comparison-dashboard/production-comparison-pdf.service';
import { ProductionComparisonReportService } from './production-comparison-dashboard/production-comparison-report.service';
import { ProductionComparisonRowsService } from './production-comparison-dashboard/production-comparison-rows.service';
import { ProductionHistoryDashboardComponent } from './production-history-dashboard/production-history-dashboard.component';
import { ProductionReconciliationDashboardComponent } from './production-reconciliation-dashboard/production-reconciliation-dashboard.component';
import { ReportEntityFilterModule } from '../../components/report-entity-filter/report-entity-filter.module';
import { ProjectionMethodHelpComponent } from '../../components/projection-method-select/projection-method-help.component';

@NgModule({
  declarations: [
    ProductionComparisonDashboardComponent,
    ProductionHistoryDashboardComponent,
    ProductionReconciliationDashboardComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    DxButtonModule,
    DxChartModule,
    DxCheckBoxModule,
    DxDataGridModule,
    DxDateBoxModule,
    DxDateRangeBoxModule,
    DxDropDownBoxModule,
    DxDropDownButtonModule,
    DxFormModule,
    DxListModule,
    DxLoadPanelModule,
    DxPopupModule,
    DxPopoverModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxTagBoxModule,
    DxTextBoxModule,
    DxValidatorModule,
    ModalWindowModule,
    ReportUnavailableComponent,
    ReportEntityFilterModule,
    ProductionComparisonPdfPreviewComponent,
    ProjectionMethodHelpComponent,
  ],
  exports: [
    ProductionComparisonDashboardComponent,
    ProductionHistoryDashboardComponent,
    ProductionReconciliationDashboardComponent,
  ],
  providers: [
    ProductionComparisonReportService,
    ProductionComparisonRowsService,
    ProductionComparisonExportService,
    ProductionComparisonExportBuilderService,
    ProductionComparisonPdfService,
  ],
})
export class ProductionDashboardsModule {}
